import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

/** Une lo compartido (título, texto y enlace) en un borrador para el chat. */
export function sharedDraft(params: URLSearchParams): string {
  const parts = ['title', 'text', 'url'].map((k) => params.get(k)?.trim() ?? '').filter(Boolean);
  // Algunas apps repiten el enlace dentro del texto: no se duplica.
  const unique = parts.filter((p, i) => !parts.some((q, j) => j !== i && q.includes(p) && q.length > p.length));
  return [...new Set(unique)].join(' ').slice(0, 500);
}

/** Destino de "Compartir con HabitOS": abre el chat con lo compartido como borrador. */
export function ShareTarget() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    const draft = sharedDraft(params);
    navigate(draft ? `/chat?draft=${encodeURIComponent(draft)}` : '/chat', { replace: true });
  }, [params, navigate]);
  return null;
}
